<template>
  <v-card flat class="container--fluid">
    <v-card flat class="container--fluid bg-gray no-margins elevation-1 not-rounded">
      <v-card flat class="v-card__container">
        <v-card-title class="no-margins">
          <h4>Misslyckade distansbeställningar</h4>
          <v-spacer></v-spacer>
        </v-card-title>
      </v-card>
    </v-card>
    <v-data-table
        :headers="headers"
        :items="educations"
        :options.sync="options"
        :server-items-length="totalRows"
        :items-per-page="itemsPerPage"
        item-key="orderId"
        class="mt-6 mx-6 clickable"
        sort-by="updatedAt"
        :sort-desc="[true]"
    >
      <!-- Order id header -->
      <template slot="item.id" slot-scope="props">
        <div style="text-align: right; padding-right: 28px">
          <router-link
              :to="{
              name: 'OrderDetail',
              params: {id: props.item.distanceOrderId || -1}
            }"
          >{{ props.item.distanceOrderId }}
          </router-link>
        </div>
      </template>
      <!-- Order type header -->
      <template slot="item.type" slot-scope="props">
        <div style="min-width: 100px">{{ props.item.type }}</div>
      </template>
      <!-- Company id header -->
      <template slot="item.companyName" slot-scope="props">
        <div style="min-width: 150px">
          <router-link :to="'/companies/' + props.item.distanceOrder.company.id || ''">
            {{ props.item.distanceOrder.company.name || '' }}
          </router-link>
        </div>
      </template>
      <template slot="item.person.fullName" slot-scope="props">
        <div style="min-width: 150px">{{ getFullName(props.item.person || '') }}
        </div>
      </template>
      <template slot="item.sentToCompanyForApprovalAt" slot-scope="props">
        <div style="width: 130px">{{ props.item.sentToDistanceEducationProviderAt | date }}</div>
      </template>
      <template slot="item.distanceEducationProvider.name" slot-scope="props">
        <div style="width: 130px">{{ props.item.distanceOrder.distanceEducationProvider.name }}</div>
      </template>
      <template slot="item.failureResult" slot-scope="props">
        <v-btn @click="showModal(props.item.sentError)">Visa</v-btn>
      </template>
      <template slot="item.resendButton" slot-scope="props">
        <div style="width: 30px; margin: 0 auto">
          <v-icon @click="resendEducation(props.item.id)">$sl-refresh</v-icon>
        </div>
      </template>
      <template slot="item.markAsSentButton" slot-scope="props">
        <div style="width: 30px; margin: 0 auto">
          <v-icon @click="markAsSent(props.item.id)">$sl-check</v-icon>
        </div>
      </template>
    </v-data-table>
    <v-dialog v-model="resultModal" max-width="581">
      <v-card>
        <v-card-title>
          <div class="display-1">FAILURE INFO</div>
        </v-card-title>

        <v-icon class="close" @click="hideModal">$sl-close</v-icon>

        <v-card-text class="mt-n7">
          <div>
            {{ sentError }}
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import {pageSize} from '@/store/constants'
import Criterias from '@/components/mixins/Criterias'

const SugarDate = require('sugar/date')

export default {
  name: 'FailedEducations',

  mixins: [Criterias],

  data: () => ({
    options: {},
    resultModal: false,
    itemsPerPage: pageSize,
    sentError: null,
    totalRows: 0,
    educations: [],
    headers: [
      {text: 'Nr.', value: 'id', width: "70"},
      {text: 'Typ', value: 'type'},
      {text: 'Företag', value: 'companyName'},
      {text: 'Avser', value: 'person.fullName'},
      {text: 'Skickad*', value: 'sentToCompanyForApprovalAt'},
      {text: 'Distansleverantör*', value: 'distanceEducationProvider.name', width: '200'},
      {text: 'Fel', value: 'failureResult'},
      {text: 'Skicka igen', value: 'resendButton'},
      {text: 'Mark. som skickad', value: 'markAsSentButton'},
    ],
  }),

  created() {
    const locationCriteria = this.getCriteriaFromLocation('c')

    if (locationCriteria) {
      this.options = {
        page: locationCriteria.page,
        itemsPerPage: locationCriteria.pageSize,
        sortBy: [locationCriteria.sortBy],
        sortDesc: [locationCriteria.sortDesc]
      }
    }
  },

  computed: {
    ...mapGetters('app', ['isLoading'])
  },

  watch: {
    options: {
      handler(newOptions, oldOptions) {
        const pageChanged = oldOptions.page !== newOptions.page
        this.fetchListOptions(pageChanged)
      },
      deep: true
    },
  },

  methods: {
    ...mapActions('order', ['setSelectedOrder']),

    getFullName(person) {
      return person.firstName + ' ' + person.lastName;
    },

    fetchListOptions(pageChanged) {
      if (!pageChanged && this.options.page > 1) {
        this.options.page = 1
      } else {
        this.fetchList()
      }
    },
    showModal(sentError) {
      this.resultModal = true;
      this.sentError = sentError;
    },
    hideModal() {
      this.resultModal = false;
      this.sentError = null;
    },
    async resendEducation(educationId) {
      const res = await this.$dialog.confirm({
        title: 'Skicka igen?',
        text: `Skicka beställningen igen? Om ingen åtgärd gjorts i registret eller hos distansleverantören kommer förmodligen beställningen att misslyckas igen.`,
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Skicka', key: true, icon: '$sl-check', outlined: true}
        ]
      })

      if (!res) {
        return
      }

      try {
        await API.resendEducation(educationId);
        await this.fetchList();
      } catch (e) {
        console.log(e);
      }
    },
    async markAsSent(educationId) {
      const res = await this.$dialog.confirm({
        title: 'Markera som skickad?',
        text: `Markera beställningen son skickad?`,
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Markera', key: true, icon: '$sl-check', outlined: true}
        ]
      })

      if (!res) {
        return
      }

      try {
        await API.markAsSent(educationId);
        await this.fetchList();
      } catch (e) {
        console.log(e);
      }
    },
    async fetchList() {
      const {sortBy, sortDesc, page} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      this.criteria = {
        page: page,
        startAt: startAt,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
        search: this.search,
        pageSize: this.itemsPerPage,
        educations: []
      }

      try {
        const response = await API.getFailedEducations(this.criteria);
        this.setCriteriaToLocation('c', this.criteria)
        this.educations = await response.data.rows
        this.totalRows = await response.data.count
      } catch (err) {
        console.log('There was an error:', err)
      }
    },
  }
}
</script>
